module.exports = {
  MAIL: { api: 'MAIL', human: 'An E-Mail-Adresse senden' },
  PRINT: { api: 'PRINT', human: 'Ausdrucken und aushändigen' }
}
